import { ChangeEvent, Dispatch, useCallback, useState } from 'react';

/**
 * Hook to reduce amount of code with simple form inputs.
 * todo: Later add some 'validate' or 'mask' parameter if it is needed.
 */
export function useDomInputValue<T extends string>(
  initialState: T | (() => T),
  validate?: (value: T) => boolean,
): [T, Dispatch<T>, (event: ChangeEvent<HTMLElement>) => void] {
  const [value, setValue] = useState(initialState);
  const onDomInputChange = useCallback((event: ChangeEvent<HTMLElement>) => {
    const value: T = (event.target as any)['value'];

    if (validate ? validate(value) : true) {
      setValue(value);
    }
  }, []);

  return [value, setValue, onDomInputChange];
}
